import { ReactElement } from 'react';
import React from 'react';

import { BlockedChatHeader } from '../../../components/blockedChat/blockedChatHeader';
import { BlockedUserContainer } from '../../../components/blockedChat/blockedUserContainer';
import { ChatContentContainer } from '../../../components/layout/chatContentContainer';
import { HeaderContainer } from '../../../components/layout/headerContainer';

const BlockedUser = (): ReactElement => {
	return (
		<>
			<HeaderContainer>
				<BlockedChatHeader />
			</HeaderContainer>
			<ChatContentContainer>
				<BlockedUserContainer />
			</ChatContentContainer>
		</>
	);
};

export { BlockedUser };
